<template>
  <div class="gallery_sm">
    <vueper-slides
      fade
      :touchable="false"
      :bullets="false"
      fixed-height="233px"
    >
      <vueper-slide
        v-for="(slide, i) in gallerySides"
        :key="i"
        :image="slide.image"
      />
    </vueper-slides>
  </div>
</template>

<script>
import { VueperSlides, VueperSlide } from "vueperslides";
import "vueperslides/dist/vueperslides.css";
import "./GallerySm.scss";

export default {
  name: "GallerySm",
  components: { VueperSlides, VueperSlide },
  props: ["pageData"],
  computed: {
    gallerySides() {
      if (!this.pageData?.gallery) return [];
      return this.pageData?.gallery.map((img, i) => {
        return {
          image: `${process.env.VUE_APP_API_URL}/${img?.path}`,
        };
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>